var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseDrawer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3018 11.3019C10.8994 11.7043 10.8994 12.3569 11.3018 12.7594L16.5418 18.0001L11.3021 23.2406C10.8996 23.6431 10.8996 24.2957 11.3021 24.6981C11.7045 25.1006 12.357 25.1006 12.7594 24.6981L17.9992 19.4577L23.2388 24.698C23.6412 25.1005 24.2937 25.1005 24.6961 24.698C25.0985 24.2955 25.0985 23.6429 24.6961 23.2405L19.4565 18.0001L24.6964 12.7595C25.0988 12.3571 25.0988 11.7045 24.6964 11.302C24.2939 10.8995 23.6415 10.8995 23.239 11.302L17.9992 16.5426L12.7591 11.3019C12.3567 10.8994 11.7043 10.8994 11.3018 11.3019Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseDrawer);
export default __webpack_public_path__ + "static/media/icon__close_drawer.a297fce0b1b0748f14d2abcb8b3433ca.svg";
export { ForwardRef as ReactComponent };